// extracted by mini-css-extract-plugin
export default {"filters":"AlarmSettingsScreen_filters__7BfIx"};